import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import TablePaginationButtons from "./TablePaginationButtons";
import SortableTableHeader from "./SortableTableHeader";
import CreateOrderTableCells from "./CreateOrderTableCells";

const MonthlyParkingCustomerOrdersModal = ({
    isOpen,
    onClose,
    orders = [],
    filters,
    pageSize = 10,
}) => {
    const [orderPage, setOrderPage] = useState(1);
    const [sortConfig, setSortConfig] = useState(null);

    const sortedOrders = (orders) => {
        if (sortConfig) {
            const { key, direction } = sortConfig;
            return [...orders].sort((a, b) => {
                const aValue = a[key] || "";
                const bValue = b[key] || "";
                if (aValue < bValue) return direction === "asc" ? -1 : 1;
                if (aValue > bValue) return direction === "asc" ? 1 : -1;
                return 0;
            });
        }

        // Default sort: newer first
        return [...orders].sort(
            (a, b) => new Date(b.date_created) - new Date(a.date_created)
        );
    };

    const paginatedOrders = sortedOrders(orders).slice(
        filters.pagination ? (orderPage - 1) * pageSize : 0,
        filters.pagination ? orderPage * pageSize : undefined
    );

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="xl">
            <ModalHeader toggle={onClose}>
                {orders.length > 0
                    ? `${orders[0]?.customer_first_name || ""} ${orders[0]?.customer_last_name || ""} Orders`
                    : "Customer Orders"}
            </ModalHeader>
            <ModalBody>
                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table className="table align-middle table-hover table-nowrap mb-0">
                        <SortableTableHeader
                            columns={[
                                { label: "Location", sortKey: "locationName" },
                                { label: "Date", sortKey: "date_created" },
                                { label: "Customer" },
                                { label: "Items" },
                                { label: "Payment Method" },
                                { label: "Status" },
                                { label: "Total" },
                                ...(filters.showBarcode ? [{ label: "Barcode" }] : []),
                                { label: "" },
                            ]}
                            onSort={setSortConfig}
                        />
                        <tbody>
                            {paginatedOrders.map((o) => (
                                <tr key={o.id}>
                                    <td>{o.locationName}</td>
                                    <CreateOrderTableCells
                                        o={o}
                                        filters={filters}
                                        user={JSON.parse(localStorage.getItem("authUser"))}
                                        reloadTime={() => { }}
                                        showDelete={false}
                                    />
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {filters.pagination && orders.length > pageSize && (
                    <TablePaginationButtons
                        currentPage={orderPage}
                        totalItems={orders.length}
                        pageSize={pageSize}
                        onPageChange={setOrderPage}
                    />
                )}
            </ModalBody>
        </Modal>
    );
};

export default MonthlyParkingCustomerOrdersModal;